<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Webhooks'"
      [canGoBack]="true"
      [customBack]="'more/developers'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Add webhooks and we will send events to that url.'" /><span>&nbsp;</span>
          <tidy-text
            [body]="'Learn More'"
            (action)="goToLearnMore()"
            class="link" />
        </tidy-row>
        <tidy-button
          [text]="'Add Endpoint'"
          [action]="boundGoToAddWebhook"
          class="primary" />
        <tidy-row class="extra-top-padding">
          <tidy-text
            [header]="'Endpoints Receiving Events'" />
        </tidy-row>
        @if (webhookResponse.length === 0) {
          <tidy-alert>
            <tidy-row>
              <tidy-text
                [body]="'No Active Webhooks'" />
            </tidy-row>
          </tidy-alert>
        }
        @for (currentWebhook of webhookResponse; track currentWebhook; let last = $last) {
          <tidy-card>
            <tidy-card-button (action)="goToWebhookDetails(currentWebhook)">
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [header]="currentWebhook?.webhook_url"
                  [translate]="false" />
              </tidy-row>
              <tidy-row class="vertical-align-center extra-bottom-padding">
                <tidy-image
                  [src]="'assets/img/url.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="currentWebhook?.channel === 'webhook' ? 'Standard Webhook' : 'Slack Webhook'" />
              </tidy-row>
              @if (currentWebhook?.description) {
                <tidy-row class="vertical-align-center extra-bottom-padding">
                  <tidy-image
                    [src]="'assets/img/info.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="currentWebhook?.description"
                    [translate]="false" />
                </tidy-row>
              }
              <tidy-row class="vertical-align-center extra-bottom-padding">
                @if (currentWebhook.state === 'inactive') {
                  <tidy-image
                    [src]="'assets/icon/pause.svg'"
                    class="body-size" />
                }
                @if (currentWebhook.state === 'active') {
                  <tidy-image
                    [src]="'assets/icon/check.svg'"
                    class="body-size" />
                }
                <tidy-text
                  [body]="'Status:'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="currentWebhook?.state | titlecase" />
                </tidy-row>
                @if (currentWebhook?.customer_account_team && isAccountAdmin) {
                  <tidy-row class="vertical-align-middle extra-bottom-padding">
                    <tidy-image
                      [src]="'assets/img/organization.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="'Group: '" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="currentWebhook?.customer_account_team?.name"
                        [translate]="false" />
                    </tidy-row>
                  }
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/img/alert.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="'Listening to events:'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="buildWebhookEventsList(currentWebhook.events)" />
                    </tidy-row>
                  </tidy-card-button>
                </tidy-card>
              }
            }
          </tidy-wrapper>
        </ng-template>

        @if (!isRightSideContent) {
          <app-scroll-wrapper [templateContent]="content" />
        }

        @if (isRightSideContent) {
          <ion-content class="ion-content-right-column">
            <ng-container *ngTemplateOutlet="content" />
          </ion-content>
        }
